import React from 'react';
import * as S from './RedirectStatusMessage.styles';
import { RedirectStatusMessageText } from './constants';
import { RedirectStatusMessageProps } from './types';
import { Col } from 'react-bootstrap';
import { Text, Title } from '@nicheinc/campus-ds';

export default function RedirectStatusMessage({
	currentUserIsOnMobile,
	redirectFailed = false,
}: RedirectStatusMessageProps) {
	return (
		<S.ParentContainer>
			<S.NicheLogo />

			{!currentUserIsOnMobile && (
				<Col xs={10} md={5}>
					<S.TextContainer>
						<Title as="h1" size="xl" color="error.text.default">
							{RedirectStatusMessageText.DESKTOP_HEADING}
						</Title>

						<Text as="p" lineHeight="large">
							{RedirectStatusMessageText.DESKTOP_DESCRIPTION}
						</Text>
					</S.TextContainer>
				</Col>
			)}

			{currentUserIsOnMobile && (
				<Col xs={10} md={5}>
					<S.TextContainer>
						<Title
							as="h2"
							size="large"
							color={
								redirectFailed ? 'error.text.default' : 'system.text.default'
							}
							lineHeight="regular"
						>
							{redirectFailed
								? RedirectStatusMessageText.FAILED_HEADING
								: RedirectStatusMessageText.HEADING}
						</Title>

						<Text as="p" size="regular" lineHeight="medium">
							{redirectFailed
								? RedirectStatusMessageText.FAILED_DESCRIPTION
								: RedirectStatusMessageText.DESCRIPTION}
						</Text>
					</S.TextContainer>
				</Col>
			)}
		</S.ParentContainer>
	);
}
